import { BaseModel } from '../../_base/crud';

export class ContactModel extends BaseModel {
  id: number;
  contact_uuid: string;
  contact_id: string;
  company_id: number;
  entity_type: string;
  entity_id: any; // null
  pms_contact_id: number;
  first_name: string;
  last_name: string;
  address_1: string;
  address_2: string; // null
  city: string;
  state: string;
  zip: string;
  location_id: number;
  home_phone: string; // null
  cell_phone: string;
  fax: string;
  email: string;
  username: string;
  note: string; // null
  processed: boolean;
  form: any; // null
  form_data: any; // null
  is_active: boolean;
  tags: any;
  link;
  last_name2: any;
  middle_name: any;
  urbanization: any;
  dob: string;
  pin_number: number;
  entity_types: string;
  language: any;
  nickname;
  phone2;
  preferred_time: any;
  avatar;
  pre_signed_url: any;
  status: any;
  gender;
  office_number: any;
  extension: any;
  document_already_shared: boolean;

  clear() {
    this.urbanization = null;
    this.id = 0;
    this.contact_id = '';
    this.company_id = 0;
    this.entity_type = '';
    this.entity_id = null;
    this.pms_contact_id = 0;
    this.first_name = '';
    this.last_name = '';
    this.address_1 = '';
    this.address_2 = null;
    this.city = '';
    this.state = '';
    this.zip = '';
    this.location_id = 0;
    this.home_phone = null;
    this.cell_phone = null;
    this.fax = '';
    this.dob = '';
    this.email = '';
    this.username = '';
    this.note = null;
    this.processed = false;
    this.form = null;
    this.form_data = null;
    this.is_active = true;
    this.pin_number = null;
    this.entity_types = null;
    this.avatar = null;
    this.gender = null;
    this.office_number = null;
    this.extension = null;
    this.document_already_shared = false;
  }

  changeActiveStatus() {
    this.is_active = !this.is_active;
  }
}
